module.exports = __webpack_public_path__ + "static/media/banner-right-01.f95ae8fb.gif";